import React from 'react';
import { View } from 'react-native';
import Text from '@/components/Typography/Text';
import { Section, useLanding } from '@/components/Landing/LandingKit';
import { fluid } from '@/components/Landing/landingTokens';

export function ApiSection({ label, background, children }) {
  const { c, width } = useLanding();
  return <Section label={label} background={background} style={{ borderTopWidth: 1, borderTopColor: c.rule }} contentStyle={{ paddingTop: fluid(width, 44, 72), paddingBottom: fluid(width, 44, 72) }}>{children}</Section>;
}
export function ApiSplit({ children, style }) {
  const { isCompact } = useLanding();
  return <View style={{ flexDirection: isCompact ? 'column' : 'row', gap: isCompact ? 28 : 76, ...style }}>{children}</View>;
}
export function ApiTitle({ children, style }) {
  const { c, width } = useLanding();
  const size = fluid(width, 29, 38);
  return <Text tag="h2" weight="semibold" style={{ color: c.ink, fontSize: size, lineHeight: Math.round(size * 1.13), letterSpacing: -size * 0.035, ...style }}>{children}</Text>;
}
export function ApiBody({ children, style }) {
  const { c } = useLanding();
  return <Text tag="p" style={{ color: c.inkSoft, fontSize: 16, lineHeight: 27, ...style }}>{children}</Text>;
}
